/* FS - inner header: hide on the way down, back on the way up, and hand the
   shared mega menu a trigger it can actually see. */
(function () {
  var bar = document.querySelector('[data-fsih]');
  if (!bar) return;

  /* ------------------------------------------------------------------ *
   * hide on scroll down                                                 *
   * ------------------------------------------------------------------ */
  var last = window.pageYOffset;
  var hidden = false;

  function onScroll() {
    var y = window.pageYOffset;
    /* a few pixels of slack: a trackpad wobbles either side of a resting
       position and would otherwise flicker the bar on and off */
    if (Math.abs(y - last) < 6) return;

    var down = y > last;
    var past = y > bar.getBoundingClientRect().height + 40;
    var want = down && past;

    if (want !== hidden) {
      hidden = want;
      bar.classList.toggle('is-hidden', hidden);
      /* a panel hanging off a bar that has just slid away is worse than no
         panel at all */
      if (hidden) mmClose(true);
    }
    last = y;
    mmPlace();
  }

  window.addEventListener('scroll', onScroll, { passive: true });

  /* ------------------------------------------------------------------ *
   * the shared mega menu                                                *
   * ------------------------------------------------------------------ */

  /* THE PANEL IS NOT REBUILT HERE AND MUST NEVER BE. sections/fs-mega-menu
     .liquid renders one panel for the whole site and owns everything inside it
     - the category tabs, the product lists, the card. All this does is open and
     close it, because that section's own script binds its hover to Ella's nav
     (`.header__inline-menu`, `.main-menu`), and on these templates that nav is
     display:none. It found its trigger, wired it, and then nothing could ever
     hover it.

     Opening is only two classes, both of which are that section's own contract:
     `fs-mm--ready` takes it out of display:none the first time, and `is-open`
     runs the transition. Its `mouseleave` on the panel still closes it, so the
     two halves meet without either knowing about the other. */
  var mm = document.querySelector('[id^="fs-mm-"]');
  var trigger = null;
  var mmTimer = null;
  var mmReady = false;

  function mmPath(href) {
    try { return new URL(href, location.origin).pathname.replace(/\/$/, ''); }
    catch (e) { return ''; }
  }

  /* THE PANEL IS BURIED INSIDE THE HEADER STACK THIS PAGE HIDES.
     fs-mega-menu is a section in the header group, and on these templates the
     whole group is `.zoff-header-stack{ display:none }`. A descendant of a
     display:none ancestor cannot be brought back by any rule - it has no box at
     all - so the panel opened correctly and measured 0x0. Moving it to the end
     of <body> is what gives it one. Safe to move: it is position:fixed, its
     stylesheet is document-wide wherever the tag sits, and its listeners travel
     with the node. Only inner pages load this file, so the homepage keeps the
     panel exactly where the section put it. */
  function mmDetach() {
    if (!mm || mm.parentElement === document.body) return;
    var n = mm.parentElement;
    while (n && n !== document.body) {
      if (getComputedStyle(n).display === 'none') { document.body.appendChild(mm); return; }
      n = n.parentElement;
    }
  }

  /* The link is matched on the panel's OWN data-trigger rather than on the word
     "Shop", so renaming the menu entry cannot quietly unhook it. */
  function findTrigger() {
    if (!mm) return null;
    var want = mmPath(mm.dataset.trigger || '');
    if (!want) return null;
    var links = bar.querySelectorAll('.fsih__link');
    for (var i = 0; i < links.length; i++) {
      if (mmPath(links[i].getAttribute('href')) === want) return links[i];
    }
    return null;
  }

  function mmTop() {
    return Math.max(0, Math.round(bar.getBoundingClientRect().bottom + 6));
  }

  function mmPlace() {
    if (!mm || !mm.classList.contains('is-open')) return;
    document.documentElement.style.setProperty('--fsih-mm-top', mmTop() + 'px');
  }

  function mmOpen() {
    if (!mm) return;
    clearTimeout(mmTimer);
    mmDetach();
    if (!mmReady) { mm.classList.add('fs-mm--ready'); mmReady = true; }
    document.documentElement.style.setProperty('--fsih-mm-top', mmTop() + 'px');
    if (trigger && trigger.parentElement) trigger.parentElement.classList.add('is-mm-open');
    /* one frame so the display change lands before the transition */
    requestAnimationFrame(function () { mm.classList.add('is-open'); });
  }

  function mmClose(now) {
    if (!mm) return;
    clearTimeout(mmTimer);
    mmTimer = setTimeout(function () {
      mm.classList.remove('is-open');
      if (trigger && trigger.parentElement) trigger.parentElement.classList.remove('is-mm-open');
    }, now ? 0 : 140);
  }

  function mmWire() {
    trigger = findTrigger();
    if (!trigger || !mm) return false;
    mmDetach();

    var item = trigger.parentElement || trigger;
    item.addEventListener('mouseenter', function () { mmOpen(); });
    item.addEventListener('mouseleave', function () { mmClose(); });
    trigger.addEventListener('focus', function () { mmOpen(); });

    /* Crossing the gap from the bar to the panel must not close it. The section
       clears its OWN timer on this event, which does nothing for ours. */
    mm.addEventListener('mouseenter', function () { clearTimeout(mmTimer); });
    mm.addEventListener('mouseleave', function () { mmClose(); });
    mm.addEventListener('focusin', function () { clearTimeout(mmTimer); });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') mmClose(true);
    });
    window.addEventListener('resize', mmPlace, { passive: true });
    return true;
  }

  /* The panel is printed by a section in the header group, so it is normally
     already in the document by the time this deferred script runs. The retry is
     for the theme editor, which re-renders sections on their own. */
  if (!mmWire()) {
    var tries = 0;
    var poll = setInterval(function () {
      mm = mm || document.querySelector('[id^="fs-mm-"]');
      if (mmWire() || ++tries > 20) clearInterval(poll);
    }, 150);
  }
})();
